import { useEffect, useRef } from 'react';
import { useTracking } from './use-tracking';

export function usePageTracking() {
  const { page, analytics } = useTracking();
  const hasTrackedRef = useRef(false);
  // PRAT-19: o analytics fica pronto depois da 1ª renderização (busca a loja e
  // carrega os plugins). Espera a instância de verdade para registrar a página.
  const ready = typeof analytics?.page === 'function';

  useEffect(() => {
    // Só executa o tracking uma vez por montagem do componente
    if (ready && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      page();
    }
  }, [page, ready]);

  return { page };
}
